import React, {useEffect, useState, useContext} from 'react';
import { Row, Col } from 'react-bootstrap'
import Select from 'react-select'

import Get from '../../api/Get'
import { authContext } from "../../context/AuthContext";
import { ESPECIALITIES_ALL } from "../../api/Routes";


function FiltroEspecialidad({filterChange}){
    const [opciones, setOpciones] = useState([])

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)
    const accesToken = auth.data.access_token;

    useEffect(() => {
        
        Get({url: ESPECIALITIES_ALL, access_token: accesToken}).then((resp) => {
            let data = resp.data;
            let opt = []

            data.forEach( d => opt.push({value: d.id, label:d.name}));

            setOpciones(opt)
        })
        .catch((err) => {
            console.log("Error encontrado", err)
        })
    }, [])

    return (<>
        <Row className=" justify-content-md-center fitro-especialidad-contenedor">
            <Col xs="12" sm="6" md="4" lg="4" xl="4">
                <Select className="filtro-especialidad"
                    options={opciones} 
                    onChange={filterChange}
                />
            </Col>
        </Row>
    </>)
}

export default FiltroEspecialidad